export default __webpack_public_path__ + "google-ads.545aeed7.png";